import { render, staticRenderFns } from "./SecondStepWizzard.vue?vue&type=template&id=5d4b1603&scoped=true&"
import script from "./SecondStepWizzard.vue?vue&type=script&lang=js&"
export * from "./SecondStepWizzard.vue?vue&type=script&lang=js&"
import style0 from "./SecondStepWizzard.vue?vue&type=style&index=0&id=5d4b1603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b1603",
  null
  
)

export default component.exports